import { Injectable } from '@angular/core';
import { vectorTaggingToolsConfig } from '../../../../cross-team-shared/tools.config';
import {
  Point2D,
  ShapeLocation,
} from '../../../../team-apis/otterdam/answers/shape-typings';
import { getShapeHelper } from '../../shape-helpers/get-shape-helper';
import { RectangleTool } from '../rectangle/rectangle-tool';
import { MultiClickShapeToolHelper } from '../shared/tool-helpers/multi-click-shape-tool-helper';
import { SliderRectangleToolHelper } from './slider-rectangle-tool-helper';

@Injectable()
export class SliderRectangleTool extends RectangleTool {
  override readonly name = vectorTaggingToolsConfig.SliderRectangle.name;

  // Must have a constructor here until Angular 13 to work around a code
  // coverage bug: https://github.com/angular/angular/issues/44781

  override updateLocationToFollowMouse(location: ShapeLocation<Point2D>) {
    const points = location.points;
    if (points.length === 4) {
      super.updateLocationToFollowMouse(location);
      return;
    }

    points[4] = this.getImagePoint();
    location.points = getShapeHelper('slider_rectangle').fixPoints(points);
  }

  override handleInProgressMouseDown(
    helper: MultiClickShapeToolHelper,
    event: MouseEvent,
  ) {
    let points = helper.getPointsStore().state();
    if (points.length === 5) {
      void helper.stopListening(event);
      return;
    }

    const shapeHelper = getShapeHelper('slider_rectangle');
    if (!shapeHelper.arePointsValid(points)) {
      return;
    }

    // this is the second click, which finishes the rectangle
    points = shapeHelper.fixPoints([...points, this.getImagePoint()]);
    helper.addPoint(points[4]);
    helper.trackAddInProgressSubpointEvent(3);
  }

  protected override createToolHelper() {
    return new SliderRectangleToolHelper(
      this,
      this.store('vectorOverlay'),
      this.injector,
    );
  }
}
